// import fire from "../config/Fire";
import { SET_DARK_MODE, SET_LIGHT_MODE } from "./types";

export const toggleTheme = currentTheme => async dispatch => {
  if (currentTheme === "light") {
    dispatch({
      type: SET_DARK_MODE
    });
  }
  if (currentTheme === "dark") {
    dispatch({
      type: SET_LIGHT_MODE
    });
  }
};
